import { Injectable } from '@angular/core';
declare const $: any;
const loaderAnimation = '#loaderAnimation';

@Injectable({
  providedIn: 'root'
})

export class LoaderService {
  private loaderContainer = document.getElementById('loaderAnimation2');
  constructor() {
    $(loaderAnimation).hide();
  }

  show() {
    $(loaderAnimation).show();
  }

  hide() {
    $(loaderAnimation).hide();
  }
}